module.exports = __webpack_public_path__ + "img/cfo.28a5e1a3.png";